import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { getRunTopicComponentId } from '../../../../utilities/helpers';

const RunFlowTopicsObserver = ({ flow, onRunFlowTopicIdsChange }) => {
  useEffect(() => {
    if (typeof onRunFlowTopicIdsChange !== 'function') return;
    if (!Array.isArray(flow?.topics)) return;

    const visibleTopicIds = flow.topics
      .filter((topic) => !topic?.isHidden)
      .map((topic) => getRunTopicComponentId(topic))
      .filter((topicId) => topicId != null);

    onRunFlowTopicIdsChange(visibleTopicIds);
  }, [flow?.topics, onRunFlowTopicIdsChange]);

  return null;
};

RunFlowTopicsObserver.propTypes = {
  flow: PropTypes.shape({
    topics: PropTypes.arrayOf(
      PropTypes.shape({
        component_id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        componentId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        isHidden: PropTypes.bool,
        topic_id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        topicId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      })
    ),
  }),
  onRunFlowTopicIdsChange: PropTypes.func,
};

export default RunFlowTopicsObserver;
